export class OppStatus
{
    OpportunityStatusID : number;
    OpportunityStatusName : string;
    OpportunityStatusDescription : string;
    IsActive : boolean = true;
    ModifiedBy : number;
}